import { z } from "zod";
import { ORDER_SOURCE_VALUES } from "./sales";

const isoDate = z.iso.date("errors.field.date");

/** Revenue channel: the order source, or "direct" for invoices raised without an order. */
export const REPORT_CHANNEL_VALUES = [...ORDER_SOURCE_VALUES, "direct"] as const;
export type ReportChannel = (typeof REPORT_CHANNEL_VALUES)[number];
/** The sales report also shows the documents archived from the previous tool (IABAKO), as their own channel. */
export const SALES_CHANNEL_VALUES = [...REPORT_CHANNEL_VALUES, "legacy"] as const;
export type SalesChannel = (typeof SALES_CHANNEL_VALUES)[number];

export const SALES_GROUP_VALUES = ["product", "customer", "month", "channel"] as const;
export const PURCHASE_GROUP_VALUES = ["supplier", "month"] as const;

export const salesReportQuerySchema = z.object({
  from: isoDate,
  to: isoDate,
  groupBy: z.enum(SALES_GROUP_VALUES).default("product"),
  channel: z.enum(SALES_CHANNEL_VALUES).optional(),
});
export type SalesReportQuery = z.output<typeof salesReportQuerySchema>;

export const purchaseReportQuerySchema = z.object({
  from: isoDate,
  to: isoDate,
  groupBy: z.enum(PURCHASE_GROUP_VALUES).default("supplier"),
});
export type PurchaseReportQuery = z.output<typeof purchaseReportQuerySchema>;

/** Web shop only (Shopify orders and their archive) or every channel. */
export const RECONCILIATION_SCOPES = ["shopify", "all"] as const;

export const reconciliationQuerySchema = z.object({
  from: isoDate,
  to: isoDate,
  scope: z.enum(RECONCILIATION_SCOPES).default("shopify"),
});
export type ReconciliationQuery = z.output<typeof reconciliationQuerySchema>;
